<div class="flex flex-col items-stretch">
  <h4 matDialogTitle>Update Your Location</h4>

  <div mat-dialog-content>
    <div class="flex flex-col items-stretch">
      <p>Select your location from the list below</p>

      <mat-form-field>
        <mat-select
          placeholder="Location"
          name="Location"
          id="location"
          [(ngModel)]="selectedLocation"
          required="true"
          (selectionChange)="checkButtonDisabled()"
        >
          <mat-option *ngFor="let location of locations" [value]="location"
            >{{ location.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <mat-dialog-actions align="end">
    <button
      mat-raised-button
      color="primary"
      [disabled]="mustSetLocation"
      (click)="updateLocation()"
    >
      Save
    </button>
  </mat-dialog-actions>
</div>
